import React from "react";
import sellTagService from "../../../../js/common/SellTagService";
import { SellTag } from "../../../../js/models/maxEnums";
import { ProductDetailInfo } from "../ProductDetailPageTypeConfig";
import productActionPriceInfoService from "../ProductActionPriceInfoService";
import { Currency } from "../../../../js/common/CurrencyFormatter";

interface ProductGalleryPriceInfoProperties {
    readonly product: ProductDetailInfo;
    readonly actionDiscountCode: string | null;
    readonly megaClearanceSaleDiscountCode: string | null;
    readonly newProductsDiscountCode: string | null;
    readonly currency: Currency;
}

export default function ProductGalleryPriceInfo({
    product,
    actionDiscountCode,
    megaClearanceSaleDiscountCode,
    newProductsDiscountCode,
    currency,
}: ProductGalleryPriceInfoProperties): React.JSX.Element {
    const handleShowDiscountedPriceModal = (): void => {
        productActionPriceInfoService.showProductActionPriceModal(
            product,
            actionDiscountCode,
            megaClearanceSaleDiscountCode,
            newProductsDiscountCode,
            currency,
        );
    };

    if (product.discountedPrice !== null && megaClearanceSaleDiscountCode !== null && sellTagService.contains(product.sellTags, SellTag.MegaClearanceSale)) {
        return (
            <span className="visible-md visible-lg visible-xl">
                <strong>Dnes AKČNÍ CENA</strong> s kódem {megaClearanceSaleDiscountCode} <i
                    className="fa-solid fa-info-circle"
                    onClick={handleShowDiscountedPriceModal}>
                </i>
            </span>
        );
    }

    if (product.discountedPrice !== null && actionDiscountCode !== null && sellTagService.contains(product.sellTags, SellTag.Promo)) {
        return (
            <span className="visible-md visible-lg visible-xl">
                <strong>Dnes AKČNÍ CENA</strong> s kódem {actionDiscountCode} <i className="fa-solid fa-info-circle" onClick={handleShowDiscountedPriceModal}></i>
            </span>
        );
    }

    if (product.discountedPrice !== null && sellTagService.contains(product.sellTags, SellTag.IsNew)) {
        return (
            <span className="visible-md visible-lg visible-xl">
                <strong>Dnes AKČNÍ CENA</strong> s kódem {newProductsDiscountCode}
                <button type="button" onClick={handleShowDiscountedPriceModal}><i className="fa-solid fa-info-circle"></i></button>
            </span>
        );
    }

    return (
        <span>Cena od Karla</span>
    );
}
